<template>
  <b-row>
    <b-col sm="12">
      <my-card title="Daftar Satuan">
        <template slot="button">
          <button-add v-if="cP(54)" :to="{name: 'units-add'}" variant="primary"></button-add>
        </template>
        <template slot="body">
          <data-tables sortKey="1" ref="datatables" endpoint="v1/units" :fields="fields">
            <template v-slot:0="{item}">
              {{item[1]}}
            </template>
            <template v-slot:2="{item}">
              <div class="float-none">
                <button-link v-if="cP(55)" size="sm" :to="{name:'units-edit',params:{id: item[2]}}" feather-icon="EditIcon"></button-link>
                <button-delete v-if="cP(56)" @ondelete="deleteRow" :id="item[2]" :name="`${item[1]}`"></button-delete>
              </div>
            </template>
          </data-tables>
        </template>
      </my-card>
    </b-col>
  </b-row>
</template>

<script>
import ButtonAdd from '@/my-components/ButtonAdd.vue'
import DataTables from '@/my-components/DataTables.vue'
import ButtonDelete from '@/my-components/ButtonDelete.vue'
import ButtonLink from '@/my-components/ButtonLink.vue'

export default {
  components:{
    ButtonAdd,
    DataTables,
    ButtonDelete,
    ButtonLink,
  },
  data() {
    return {
      fields: {
        1:{sortable: true, searchable: true, label:'Nama'},
        2:{sortable: false, searchable: true, label:''},
      }
    }
  },
  methods:{
    async deleteRow(payload){
      try {
        await this.$store.dispatch('units/destroy',payload)
        this.$refs.datatables.refresh()
        this.toastSuccess("OK","Data Berhasil Dihapus!")
      } catch (error) {
        this.handleError(error)
      }
    }
  }
}
</script>

<style>

</style>